// SectionTracker.jsx
// Wrap any showcase section with this to get automatic view/dwell-time tracking,
// without touching the section's own internals. Also tags its wrapper with
// data-track-section so InteractionTracker knows which section a click/hover
// happened inside.
//
// Usage in e.g. SectionWebDesignNew.jsx:
//   <SectionTracker name="web-design">
//     <SectionWebDesignNew />
//   </SectionTracker>

import React, { useEffect, useRef } from "react";
import { markSectionEntered, markSectionExited } from "./sectionEventQueue";

export default function SectionTracker({ name, children, threshold = 0 }) {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          markSectionEntered(name);
        } else {
          markSectionExited(name);
        }
      },
      { threshold }
    );

    observer.observe(node);

    return () => {
      markSectionExited(name); // treat unmount as leaving the section
      observer.disconnect();
    };
  }, [name, threshold]);

  return (
    <div ref={ref} data-track-section={name}>
      {children}
    </div>
  );
}